<div class="tw-text-center" *ngIf="shouldShow$ | async">
  <p class="tw-mb-0">{{ "doNotHaveExtension" | i18n }}</p>
  <a bitLink [href]="webStoreUrl" target="_blank" rel="noreferrer">
    {{ "installExtension" | i18n }}
  </a>
</div>
